module.exports = __webpack_public_path__ + "static/media/TJ-Can.eb3935ad.svg";